import axios from 'axios'
import {ID} from '../../../../_metronic/helpers'
import {Profile, ProfilesQueryResponse} from './_models'

const API_URL = process.env.REACT_APP_API_URL
const PROFILE_URL = `${API_URL}/profile`

const getProfiles = (query: string): Promise<ProfilesQueryResponse> => {
  return axios.get(`${PROFILE_URL}?${query}`)
}

const getProfile = (): Promise<Profile> => {
  return axios.get(`${PROFILE_URL}/me`)
}

const getProfileById = (id: ID): Promise<Profile | undefined> => {
  return axios.get(`${PROFILE_URL}/${id}`)
}

const createProfile = (profile: Profile): Promise<Profile | undefined> => {
  return axios.post(PROFILE_URL, profile)
}

const updateProfile = (profile: Profile): Promise<Profile | undefined> => {
  return axios.patch(`${PROFILE_URL}`, profile)
}

const deleteProfile = (profileId: ID): Promise<void> => {
  return axios.delete(`${PROFILE_URL}/${profileId}`)
}

const deleteSelectedProfiles = async (profileIds: Array<ID>): Promise<void> => {
  const requests = profileIds.map((id) => axios.delete(`${PROFILE_URL}/${id}`))
  await axios.all(requests)
}

export {
  getProfile,
  getProfiles,
  deleteProfile,
  deleteSelectedProfiles,
  getProfileById,
  createProfile,
  updateProfile,
}
